import { PlanYear } from '@coverright/data-access/types/medicare';
import { GetDefaultPlansYear } from './GetPlansYear';

const deductibles: {[year: number]: Deductible} = {
  2022: {
    inpatientHospitalDeductible: '$1,556',
    dailyCoinsurance61_90: '$389',
    lifetimeReserveDays: '$778',
    skilledNursingFacility: '$194.50',
    annualPartBDeductible: '$233',
    standardPartBMonthlyPremium: '$170.10',
    initialCoverageLimit: '$4,430',
    catastrophicCoverageLimit: '$7,050',
    deductible: '$2,490',
    planKOutOfPocket: '$7,060',
    planLOutOfPocket: '$3,530',
    maxPartAPremium: '',
  },
  2023: {
    inpatientHospitalDeductible: '$1,600',
    dailyCoinsurance61_90: '$400',
    lifetimeReserveDays: '$800',
    skilledNursingFacility: '$200.00',
    annualPartBDeductible: '$226',
    standardPartBMonthlyPremium: '$164.90',
    initialCoverageLimit: '$4,660',
    catastrophicCoverageLimit: '$7,400',
    deductible: '$2,700',
    planKOutOfPocket: '$7,060',
    planLOutOfPocket: '$3,530',
    maxPartAPremium: '',
  },
  2024: {
    inpatientHospitalDeductible: '$1,632',
    dailyCoinsurance61_90: '$408',
    lifetimeReserveDays: '$816',
    skilledNursingFacility: '$204.00',
    annualPartBDeductible: '$240',
    standardPartBMonthlyPremium: '$174.70',
    initialCoverageLimit: '$5,030',
    catastrophicCoverageLimit: '$8,000',
    deductible: '$2,800',
    planKOutOfPocket: '$7,060',
    planLOutOfPocket: '$3,530',
    maxPartAPremium: '',
  },
  2025: {
    inpatientHospitalDeductible: '$1,676',
    dailyCoinsurance61_90: '$419',
    lifetimeReserveDays: '$838',
    skilledNursingFacility: '$209.50',
    annualPartBDeductible: '$257',
    standardPartBMonthlyPremium: '$185.00',
    initialCoverageLimit: '$2,000',
    catastrophicCoverageLimit: '$2,000',
    deductible: '$2,800',
    planKOutOfPocket: '$7,220',
    planLOutOfPocket: '$3,610',
    maxPartAPremium: '$518',
  },
  2026: {
    inpatientHospitalDeductible: '$1,736',
    dailyCoinsurance61_90: '$434',
    lifetimeReserveDays: '$868',
    skilledNursingFacility: '$217',
    annualPartBDeductible: '$283',
    standardPartBMonthlyPremium: '$202.90',
    initialCoverageLimit: '$2,100',
    catastrophicCoverageLimit: '$2,100',
    deductible: '$2,950',
    planKOutOfPocket: '$8,000',
    planLOutOfPocket: '$4,000',
    maxPartAPremium: '$565',
  },
}

export const getDeductible = (key: keyof Deductible, year?: number | PlanYear | null) => {
  if (year && !Number.isInteger(year)) {
    year = Number(year.toString().replace('Year', ''))
  }
  return deductibles[year as number || parseFloat(GetDefaultPlansYear().toString().replace('Year', ''))][key];
}

export const getStandardPartBMonthlyPremiumTable = () => ({
  '$202.90': ['$109,000 or less', '$218,000 or less'],
  '$284.10': ['up to $137,000', 'up to $274,000'],
  '$405.80': ['up to $171,000', 'up to $342,000'],
  '$527.50': ['up to $205,000', 'up to $410,000'],
  '$649.20': ['up to $500,000', 'up to $750,000'],
  '$689.90': ['$500,000 +', '$750,000 +'],
})

interface Deductible {
  inpatientHospitalDeductible: string;
  dailyCoinsurance61_90: string;
  lifetimeReserveDays: string;
  skilledNursingFacility: string;
  annualPartBDeductible: string;
  standardPartBMonthlyPremium: string;
  initialCoverageLimit: string;
  catastrophicCoverageLimit: string;
  deductible: string;
  planKOutOfPocket: string;
  planLOutOfPocket: string;
  maxPartAPremium: string;
}
